import React from 'react';
import PropTypes from 'prop-types';
import { BundleRoute } from '@saucelabs/sl-component-router';
import { LoginRequiredContainer } from '@saucelabs/sl-container-authentication';

const importMigrationWizard = () => import(/* webpackChunkName: "migration-wizard" */ './containers/MigrationWizardContainer');


const MigrationWizardRoutes = ({ match }) => (
  <LoginRequiredContainer>
    <BundleRoute
      load={importMigrationWizard}
      path={match.url}
    />
  </LoginRequiredContainer>
);

MigrationWizardRoutes.propTypes = {
  match: PropTypes.object.isRequired,
};

export default MigrationWizardRoutes;
export { MigrationWizardRoutes };
